import { BrowserRouter as Router, Route , Switch} from 'react-router-dom';
import Home from './view/Home/Home';
import Ref from './view/Ref';


function App() {

  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/ref/:refaddr" exact component={Ref} />
      </Switch>
	  </Router>
  );
}

export default App;
